import { connect } from "react-redux"
import LoginForm from "../index"
import { Dispatch } from "@redux/store"

const mapDispatch = (dispatch: Dispatch) => ({
  onSubmit: dispatch.customer.loginCustomer,
})

export default connect(undefined, mapDispatch)(LoginForm)
